import React from 'react'
import './StepIndicator.css'

// Step labels for better UX - follows best practice of descriptive step names
const DEFAULT_STEP_LABELS = ['League', 'Skill Level', 'Court', 'Payment', 'Review']

function StepIndicator({
  currentStep,
  totalSteps,
  showCompleted = false,
  stepLabels = DEFAULT_STEP_LABELS,
}) {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1)

  return (
    <div className="step-indicator" role="navigation" aria-label="Registration progress">
      <div className="step-progress-bar">
        {steps.map((step) => {
          const isActive = step <= currentStep
          const isCompleted = step < currentStep || showCompleted
          const label = stepLabels[step - 1] || `Step ${step}`
          
          return (
            <div
              key={step}
              className={`step-item ${isActive ? 'active' : ''} ${
                isCompleted ? 'completed' : ''
              }`}
            >
              <div className="step-circle-wrapper">
                <div
                  className="step-circle"
                  aria-label={`${label}: ${
                    isCompleted ? 'completed' : isActive ? 'current' : 'upcoming'
                  }`}
                  aria-current={step === currentStep && !showCompleted ? 'step' : undefined}
                >
                  {isCompleted ? (
                    <span className="checkmark" aria-hidden="true">✓</span>
                  ) : (
                    <span aria-hidden="true">{step}</span>
                  )}
                </div>
                <div className="step-label" aria-hidden="true">
                  {label}
                </div>
              </div>
              {step < totalSteps && <div className="step-line" aria-hidden="true" />}
            </div>
          )
        })}
      </div>
      <p className="step-counter" role="status" aria-live="polite">
        {showCompleted
          ? 'All steps completed! 🎉'
          : `Step ${currentStep} of ${totalSteps}: ${stepLabels[currentStep - 1] || `Step ${currentStep}`}`}
      </p>
    </div>
  )
}

export default StepIndicator
